export default __webpack_public_path__ + "static/media/checked.3be44f5e.svg";